import styled from 'styled-components';

export const SLinks = styled.div`
    display: flex;
    margin-top: 2rem;
    justify-content: center;
`;
